import React from 'react'
import { ReactComponent as Items } from '../../assets/ic_items.svg';

const ItemsIcon = () => <Items />;

export default ItemsIcon;
